module.exports = __webpack_public_path__ + "static/img/2.399f0bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/sp/2.png
// module id = h4jj
// module chunks = 0